<template>
    <div class="icon-credit-footer">
        <div>Icons made by <a href="http://www.flaticon.com/authors/roundicons" title="Roundicons">Roundicons</a>, 
        <a href="http://www.flaticon.com/authors/vectors-market" title="Vectors Market">Vectors Market</a>,
        <a href="http://www.freepik.com" title="Freepik">Freepik</a>
        from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a> is licensed by 
        <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a>
        </div>
        
        
    </div>
</template>

<script>
export default{
    
}
</script>

<style scoped>
.icon-credit-footer{
    text-align:  center;
    font-size: 11px;
}
</style>